import { NamedEntityPropertyType } from '../../../../common-modules/interfaces/NamedEntityPropertyType';

export enum SecurityAddOnStatusEnum {
    Active = 'active',
    Declined = 'declined',
    Expired = 'expired',
    Not_available = 'Not available',
}

export const SecurityAddOnStatusMapping: {
    [type in SecurityAddOnStatusEnum]: { name: string };
} = {
    [SecurityAddOnStatusEnum.Active]: {
        name: $localize`Active`,
    },
    [SecurityAddOnStatusEnum.Declined]: {
        name: $localize`Declined`,
    },
    [SecurityAddOnStatusEnum.Expired]: {
        name: $localize`Expired`,
    },
    [SecurityAddOnStatusEnum.Not_available]: {
        name: $localize`Not available`,
    },
};

export class SecurityAddOnStatus implements NamedEntityPropertyType {
    public getName(securityStatus: SecurityAddOnStatusEnum): string {
        return SecurityAddOnStatusMapping[securityStatus].name;
    }

    public getAllTypes(): SecurityAddOnStatusEnum[] {
        return Object.keys(SecurityAddOnStatusMapping) as any as SecurityAddOnStatusEnum[];
    }
}
